import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "mb-24" }
const _hoisted_2 = { class: "text-white flex-1 col-span-1 border-0 rounded-t-xl overflow-hidden" }
const _hoisted_3 = { class: "bg-theme-green px-4 py-2 text-white" }
const _hoisted_4 = { class: "flex justify-between items-center" }
const _hoisted_5 = { class: "flex flex-col justify-start text-start" }
const _hoisted_6 = { class: "font-semibold truncate text-single-line break-all mb-0.5 text-xl leading-6 mt-0 ml-2 capitalize" }
const _hoisted_7 = { class: "flex flex-col" }
const _hoisted_8 = { class: "flex items-center content-center gap-2" }
const _hoisted_9 = { class: "bg-[#2B2C32] px-[16px] py-[16px] rounded-b-lg" }
const _hoisted_10 = { class: "flex items-center xl:flex-row flex-col gap-3 mb-3" }
const _hoisted_11 = { class: "w-full xl:w-1/2" }
const _hoisted_12 = { class: "input-wrapper" }
const _hoisted_13 = { class: "flex items-center p-2 text-white h-[40px] rounded bg-[#1C1D21] w-full leading-5 text-base" }
const _hoisted_14 = { class: "mr-2" }
const _hoisted_15 = { class: "w-full xl:w-1/2" }
const _hoisted_16 = { class: "input-wrapper relative" }
const _hoisted_17 = { class: "flex items-center p-2 text-white h-[40px] rounded bg-[#1C1D21] w-full leading-5 text-base" }
const _hoisted_18 = { class: "flex items-center xl:flex-row flex-col gap-3 mb-3" }
const _hoisted_19 = { class: "w-full xl:w-1/2" }
const _hoisted_20 = { class: "input-wrapper" }
const _hoisted_21 = { class: "flex items-center p-2 text-white h-[40px] rounded bg-[#1C1D21] w-full leading-5 text-base" }
const _hoisted_22 = { class: "w-full xl:w-1/2" }
const _hoisted_23 = { class: "input-wrapper relative" }
const _hoisted_24 = {
  key: 0,
  class: "flex items-center xl:flex-row flex-col gap-3 mb-3"
}
const _hoisted_25 = { class: "w-full xl:w-1/2" }
const _hoisted_26 = { class: "input-wrapper" }
const _hoisted_27 = { class: "flex items-center p-2 text-white h-[40px] rounded bg-[#1C1D21] w-full leading-5 text-base" }
const _hoisted_28 = { class: "w-full" }
const _hoisted_29 = { class: "input-wrapper relative" }
const _hoisted_30 = { class: "h-[80px] rounded bg-[#1C1D21] text-white p-2 w-full leading-5 text-base" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("h2", _hoisted_6, _toDisplayString(_ctx.item.transactionType), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("button", {
                onClick: _cache[0] || (_cache[0] = _withModifiers(
//@ts-ignore
(...args) => (_ctx.clearComponent && _ctx.clearComponent(...args)), ["prevent"])),
                class: "text-base flex items-center justify-center text-center h-[44px] tracking-[0.15px] font-medium cursor-pointer p-4 rounded hover:opacity-60 text-white ml-3"
              }, "CLOSE")
            ])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              _cache[1] || (_cache[1] = _createElementVNode("label", { class: "text-sm leading-[17.5px]" }, "Date", -1)),
              _createElementVNode("span", _hoisted_13, [
                _createElementVNode("p", _hoisted_14, _toDisplayString(_ctx.formatDate(_ctx.item.createdAt)), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _cache[2] || (_cache[2] = _createElementVNode("label", { class: "text-sm leading-[17.5px]" }, "User", -1)),
              _createElementVNode("span", _hoisted_17, [
                _createElementVNode("p", null, _toDisplayString(_ctx.item.createdByName), 1)
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          _createElementVNode("div", _hoisted_19, [
            _createElementVNode("div", _hoisted_20, [
              _cache[3] || (_cache[3] = _createElementVNode("label", { class: "text-sm leading-[17.5px]" }, "Transaction Type", -1)),
              _createElementVNode("span", _hoisted_21, [
                _createElementVNode("p", null, _toDisplayString(_ctx.item.transactionType), 1)
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _cache[4] || (_cache[4] = _createElementVNode("label", { class: "text-sm leading-[17.5px]" }, "Amount", -1)),
              _createElementVNode("span", {
                class: _normalizeClass([_ctx.item.transactionType=='remove cash'?'text-[#FF6868]':'', "flex items-center p-2 h-[40px] rounded bg-[#1C1D21] w-full leading-5 text-base"])
              }, [
                _createElementVNode("p", null, _toDisplayString(_ctx.getAmount(_ctx.item)), 1)
              ], 2)
            ])
          ])
        ]),
        (_ctx.item.transactionType=='bank deposit')
          ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _cache[5] || (_cache[5] = _createElementVNode("label", { class: "text-sm leading-[17.5px]" }, "Bank Deposit #", -1)),
                  _createElementVNode("span", _hoisted_27, [
                    _createElementVNode("p", null, _toDisplayString(_ctx.item.depositId), 1)
                  ])
                ])
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _cache[6] || (_cache[6] = _createElementVNode("label", { class: "text-sm leading-[17.5px]" }, "Notes", -1)),
            _createElementVNode("p", _hoisted_30, _toDisplayString(_ctx.item.note), 1)
          ])
        ])
      ])
    ])
  ]))
}